import React from "react";
import PropTypes from "prop-types";
import { Field } from "formik";
import { FormGroupBlock } from "./antd";

import ReactQuill from "react-quill"; // ES6
import "react-quill/dist/quill.snow.css"; // ES6

import "./editor.css"; // ES6

const Editor = (props) => {
    const modules = {
        toolbar: [
            [{ header: [1, 2, false] }],
            [{ color: ["red", "black", "green", "blue", "yellow", "brown", "pink"] }],
            ["bold", "italic", "underline", "strike", "blockquote"],
            [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
            ["link"],
            ["clean"],
        ],
    };

    const formats = [
        "header",
        "font",
        "size",
        "bold",
        "italic",
        "underline",
        "align",
        "strike",
        "script",
        "blockquote",
        "background",
        "list",
        "bullet",
        "indent",
        "link",
        "color",
        "code-block",
    ];

    /*
        const formats = [
            'header',
            'bold', 'italic', 'underline', 'strike', 'blockquote', 
            'list', 'bullet', 'indent',
            'link', 'image'
        ];
    */
    // Formats objects for setting up the Quill editor
    return (
        <FormGroupBlock {...props}>
            <Field name={props.name}>
                {({
                    field, // { name, value, onChange, onBlur }
                    form: { setFieldValue, touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                    meta,
                }) => (
                    <ReactQuill
                        theme="snow"
                        placeholder={props.placeholder}
                        value={field.value || ""}
                        onChange={(value) => setFieldValue(field.name, value)}
                        modules={modules}
                        formats={formats}
                    />
                )}
            </Field>
        </FormGroupBlock>
    );
};

Editor.propTypes = {
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
};

export default Editor;
